/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SearchUsersPayload,
  SearchUsersPayload$Outbound,
  SearchUsersPayload$outboundSchema,
} from "../components/searchuserspayload.js";

export type SearchUsersSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SearchUsersSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SearchUsersSecurity = {
  option1?: SearchUsersSecurityOption1 | undefined;
  option2?: SearchUsersSecurityOption2 | undefined;
};

export type SearchUsersRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  searchUsersPayload: SearchUsersPayload;
};

/** @internal */
export type SearchUsersSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SearchUsersSecurityOption1$outboundSchema: z.ZodMiniType<
  SearchUsersSecurityOption1$Outbound,
  SearchUsersSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function searchUsersSecurityOption1ToJSON(
  searchUsersSecurityOption1: SearchUsersSecurityOption1,
): string {
  return JSON.stringify(
    SearchUsersSecurityOption1$outboundSchema.parse(searchUsersSecurityOption1),
  );
}

/** @internal */
export type SearchUsersSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SearchUsersSecurityOption2$outboundSchema: z.ZodMiniType<
  SearchUsersSecurityOption2$Outbound,
  SearchUsersSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function searchUsersSecurityOption2ToJSON(
  searchUsersSecurityOption2: SearchUsersSecurityOption2,
): string {
  return JSON.stringify(
    SearchUsersSecurityOption2$outboundSchema.parse(searchUsersSecurityOption2),
  );
}

/** @internal */
export type SearchUsersSecurity$Outbound = {
  Option1?: SearchUsersSecurityOption1$Outbound | undefined;
  Option2?: SearchUsersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SearchUsersSecurity$outboundSchema: z.ZodMiniType<
  SearchUsersSecurity$Outbound,
  SearchUsersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SearchUsersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SearchUsersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function searchUsersSecurityToJSON(
  searchUsersSecurity: SearchUsersSecurity,
): string {
  return JSON.stringify(
    SearchUsersSecurity$outboundSchema.parse(searchUsersSecurity),
  );
}

/** @internal */
export type SearchUsersRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SearchUsersPayload: SearchUsersPayload$Outbound;
};

/** @internal */
export const SearchUsersRequest$outboundSchema: z.ZodMiniType<
  SearchUsersRequest$Outbound,
  SearchUsersRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    searchUsersPayload: SearchUsersPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      searchUsersPayload: "SearchUsersPayload",
    });
  }),
);

export function searchUsersRequestToJSON(
  searchUsersRequest: SearchUsersRequest,
): string {
  return JSON.stringify(
    SearchUsersRequest$outboundSchema.parse(searchUsersRequest),
  );
}
